import { useState } from 'react'
import { SwtchError } from '../../models/error'
import { useFormatMessage } from '../../helpers/intl'
import { Button, Modal, message } from 'antd'
import { AlertErrorCompact } from '../error-compact'
import { Subscription } from '../../models/subscription'
import { UnpauseSubscription } from '../../services/data-provider/subscriptions'

interface props {
  subscription: Subscription
  onCancel: () => void
  onUnpauseSubscription: () => void
}

const UnpauseSubscriptionModal: React.FC<props> = ({ subscription, onCancel, onUnpauseSubscription }) => {
  const [error, setError] = useState<SwtchError>()
  const [loading, setLoading] = useState(false)

  const closeText = useFormatMessage('dashboard.text.close', 'Close')
  const deleteMessage = useFormatMessage(
    'dashboard.subscriptionsPage.modal.cancel',
    'Are you sure you want to cancel the subscription for',
  )

  const onOk = () => {
    setError(undefined)
    setLoading(true)
    UnpauseSubscription(subscription)
      .then((msg) => {
        message.success(msg)
        onUnpauseSubscription()
      })
      .catch((error: SwtchError) => setError(error))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      title="Unpause Subscription"
      cancelText="Cancel"
      visible={true}
      onCancel={onCancel}
      onOk={onOk}
      afterClose={onCancel}
      footer={[
        <Button key="back" loading={loading} onClick={onCancel}>
          {closeText}
        </Button>,
        <Button key="submit" type="primary" danger loading={loading} onClick={onOk}>
          Unpause Subscription
        </Button>,
      ]}
    >
      <AlertErrorCompact error={error} />
      {deleteMessage} <strong>{subscription.subscriber.email} </strong>?
    </Modal>
  )
}

export default UnpauseSubscriptionModal
